import {
    AfterViewInit,
    Component,
    ElementRef,
    HostBinding,
    inject,
    Input,
    ViewChild,
} from '@angular/core';
import { IAppMenu, INavMenu } from '../../../../interfaces/IAppRoutes';

import { LayoutService } from './../../services/layout.service';
import { PreviousRouteService } from '../../services/previous-route.service';
import { AppUpdateService } from '../../services/app-update.service';

@Component({
    selector: 'pf-app-layout',
    templateUrl: './app-layout.component.html',
    styleUrls: ['./app-layout.component.scss'],
    standalone: false,
})
export class AppLayoutComponent implements AfterViewInit {
    _previousRouteService = inject(PreviousRouteService);
    _appUpdateService = inject(AppUpdateService);
    layoutService = inject(LayoutService);

    @ViewChild('layoutContainer', { static: true, read: ElementRef })
    layoutContainer!: ElementRef<HTMLElement>;
    @Input() navigation: IAppMenu[] = [];

    @HostBinding('class.header-hidden')
    get headerHidden() {
        return this.layoutService.headerHidden;
    }

    ngAfterViewInit(): void {
        this.layoutService.scrollContainer = this.layoutContainer.nativeElement;
        this.layoutService.scrollToRefreshContainer =
            this.layoutContainer.nativeElement;
    }

    expanderClickHandler() {
        this.layoutService.isCollapsed = !this.layoutService.isCollapsed;
    }

    navigationTrackByFn(_: number, menu: INavMenu) {
        return menu.displayName;
    }
}
